import Head from "next/head";
import { Content, GoogleJobsSchema } from "@/ui";
import { getRoute } from "@/functions/getRoute";
import { getGlobal } from "@/functions/getGlobal";
import { webinar_helper } from "@/helpers/webinar_helper";
import classes from "./styles.module.scss";
import Hero from "@/components/Hero";
import FormSection from "@/components/FormSection";
import Button from "@/components/Button";
import SeoHead from "@/components/SeoHead";

function convertDateFormat(dateString) {
  try {
    const dateObj = new Date(dateString);

    const day = dateObj.getDate();
    const month = dateObj.getMonth() + 1;
    const year = dateObj.getFullYear();

    const formattedDay = day.toString().padStart(2, "0");
      const monthNames = ["January", "February", "March", "April", "May", "June",
                        "July", "August", "September", "October", "November", "December"];
    const formattedMonth = monthNames[month];

    const formattedDate = `${formattedDay} ${formattedMonth} ${year}`;

    return formattedDate;
  } catch (error) {
    console.error("Invalid date format. Please provide a valid ISO 8601 string.");
    return null;
  }
}

export default function WebinarPage({ title, canonical, webinar }) {

  const global = getGlobal();

  return (
    <>
      <SeoHead title={title} canonical={canonical} />
      <main className={classes.cont}>
        <Hero title={{path: "webinar.hero.title"}} background={{path:"webinar.hero.background"}}></Hero>
        <div className={classes.sub_cont}>
          <div className={classes.content}>
            <div className={classes.left_col}>
              <div className={classes.section}>
                <div className={classes.location}>
                  <div className={`${classes.title}`}>LOCATION</div>
                  <div className={classes.value}>{webinar.location}</div>
                </div>
                <div className={classes.date}>
                  <div className={classes.title}>TIME</div>
                  <h6 className={classes.value}>{convertDateFormat(webinar.date)}</h6>
                </div>
              </div>
              <Button display="ACCESS WEBINAR" variant="black"></Button>
            </div>
            <div className={classes.right_col}>
              <span dangerouslySetInnerHTML={{ __html: webinar.content }} />
            </div>
          </div>
          <div className={classes.hidden}>
            <div className={classes.left_col}>
              <div className={classes.section}>
                <div className={classes.location}>
                  <div className={`${classes.title}`}>LOCATION</div>
                  <div className={classes.value}>{webinar.location}</div>
                </div>
                <div className={classes.date}>
                  <div className={classes.title}>TIME</div>
                  <h6 className={classes.value}>{convertDateFormat(webinar.date)}</h6>
                </div>
              </div>
              <Button display="ACCESS WEBINAR" variant="black"></Button>
            </div>
            <div className={classes.right_col}>
              <span dangerouslySetInnerHTML={{ __html: webinar.content }} />
            </div>
          </div>
        </div>
        <div className={classes.form}>
          <FormSection title={`Subscribe now`} variant="dark" formId="b41f1561-7b8d-41cf-ae20-2924ccf90a66" redirect_url="/" />
        </div>
      </main>
      
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const webinar = webinar_helper.find(url_slug);

  return {
    props: {
      title: webinar.title,
      canonical: `/webinar/${webinar.url_slug}`,
      webinar
    },
  };
}

export async function getStaticPaths() {
  return { paths: webinar_helper.toPaths(), fallback: false };
}
